var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSnooze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Snooze",
    d: "M7.493,2.662l-1.4-1.675L1.06,5.2l1.411,1.673L7.493,2.662 M22.941,5.21l-5.032-4.224l-1.413,1.675l5.033,4.222 L22.941,5.21 M12,3.329c-5.439,0-9.847,4.408-9.847,9.847c0,5.438,4.408,9.848,9.847,9.848c5.438,0,9.846-4.409,9.846-9.848 C21.848,7.737,17.438,3.329,12,3.329 M12,20.835c-4.23,0-7.659-3.429-7.659-7.659c0-4.23,3.43-7.659,7.659-7.659 c4.229,0,7.659,3.428,7.659,7.659C19.659,17.407,16.23,20.835,12,20.835 M8.718,10.987h3.972l-3.972,4.595v1.969h6.564v-2.188 h-3.971l3.971-4.596V8.799H8.718V10.987z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSnooze);
export default __webpack_public_path__ + "static/media/ic_snooze.06e7dce6e772a55bdebee902c02e2947.svg";
export { ForwardRef as ReactComponent };